const isDev = process.env.NODE_ENV === 'development';

const BASE_URL = isDev
  ? 'http://localhost:4040/api'
  : 'https://napi.prepseed.com';

export const HITECH_API = `${BASE_URL}/hightech`;
export const USERS_API = `${BASE_URL}/users`;

// Hitech project config (hardcoded)
export const HITECH_CONFIG = {
  clientId: '6a21173d27059aa900f337e2',
  phaseId: '6a21178c27059aa900f337fc',
  subgroupId: '6a21178c27059aa900f337fa',
  supergroupId: '5dd95e8097bc204881be3f2c',
};

export const getAuthHeaders = () => ({
  'Content-Type': 'application/json',
  authorization: `Token ${localStorage.getItem('hitech_admin_token')}`,
});
